module.exports = __webpack_public_path__ + "img/product_22.9d9e8bc.jpg";